import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL!;
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Database = {
  public: {
    Tables: {
      user_profiles: {
        Row: {
          id: string;
          email: string;
          full_name: string;
          phone: string | null;
          role: 'user' | 'professional' | 'admin';
          avatar_url: string | null;
          is_active: boolean;
          created_at: string;
          updated_at: string;
        };
      };
      businesses: {
        Row: {
          id: string;
          user_id: string;
          legal_name: string | null;
          trade_name: string | null;
          entity_type: string | null;
          cin: string | null;
          pan: string | null;
          tan: string | null;
          gstin: string | null;
          is_demo: boolean;
          setup_progress: number;
          created_at: string;
          updated_at: string;
        };
      };
    };
  };
};

export { createClient };